import EarthquakeMap from 'components/Maps/Earthquake/EarthquakeMap';
import React from 'react';

export const EarthquakeReports = () => {
  return (
    <div className="w-100 h-xl h-lg-2xl h-xl-3xl">
      <EarthquakeMap />
    </div>
  );
};
